module.exports = __webpack_public_path__ + "static/img/usecoupon.1c21319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usecoupon.jpg
// module id = GStB
// module chunks = 0